import {
  type VisitorLinkMetadata,
  visitorLinkMetadataSchema
} from '@stratumn/stratumn-types';

import type { LinkQueryResult } from '@/components/traceInspector/traceInspector.types';
import { rawLinkMetaSchema } from './segmentUserDetail.schema';

const SIEBEL_BOT = {
  __typename: 'Account_User',
  name: 'Siebel Bot',
  avatar:
    'https://media-api.us.stratumn.com/files/11142f75cbb0fede41b19290e24ab016a60b66ba6ca5',
  email: 'siebelBot@conduent.com',
  rowId: '0'
} as const;

const decodeBase64Json = (base64: string): unknown => {
  try {
    const bytes = Uint8Array.from(atob(base64), char => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
};

const getVisitor = (
  linkRaw: unknown
): VisitorLinkMetadata['visitor'] | undefined => {
  const raw = rawLinkMetaSchema.safeParse(linkRaw);
  if (!raw.success) {
    return;
  }
  const metadata = visitorLinkMetadataSchema.safeParse(
    decodeBase64Json(raw.data.meta.data)
  );
  return metadata.data?.visitor;
};

const visitorName = (visitor: VisitorLinkMetadata['visitor']) =>
  visitor.verification
    ? `${visitor.email} · via visitor link · code verified`
    : `${visitor.email} · via visitor link`;

/** Let's hope this is temporary :) */
export const getLinkCreatedBy = (
  link: LinkQueryResult,
  linkCreatedByAccount: any,
  linkRaw?: unknown
) => {
  const visitor = getVisitor(linkRaw);
  if (visitor) {
    return {
      name: visitorName(visitor),
      email: visitor.email,
      avatar: undefined
    };
  }

  if (
    isAdminAndShouldBeSiebelBot(
      link.actionKey,
      linkCreatedByAccount?.entity?.email
    )
  ) {
    return SIEBEL_BOT;
  }
  return linkCreatedByAccount?.entity;
};

const isAdminAndShouldBeSiebelBot = (actionKey: string, email: string) =>
  actionKey === 'updateToday' && email === 'admin@stratumn.com';
